import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchData, becomeASeller } from "../../redux/actions";
import { our_brands } from "../../redux/selectors";

const Ourbrand = () => {
  const dispatch = useDispatch();
  const data = useSelector(our_brands("our_brands"));

  useEffect(() => {
    if (!data || data.length === 0) {
      dispatch(fetchData("our_brands", "pages?path=/company-info/our-brands"));
    }
  }, [dispatch, data]);

  const section = data?.sections;

  const [bannerData, setbannerData] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [viewType, setViewType] = useState("grid");

  const filteredSection =
    section?.filter((val) =>
      val?.attributes?.brand?.name
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase())
    ) || [];

  let [active, setActive] = useState(false);
  let sidebarController = () => {
    setActive(!active);
  };

  const fetchSellerData = useCallback(async () => {
    const data = await becomeASeller();

    if (data?.page?.data?.en) {
      setbannerData(data?.page?.data?.en);
    }
  }, []);

  useEffect(() => {
    fetchSellerData();
  }, [fetchSellerData]);

  return (
    <div className="short-product">
      <div className="container container-lg">
        <div className="row gy-4">
          <div className="col-xl-12 col-lg-4 col-sm-6">
            <div className="product-card d-flex flex-column h-100 p-8  ">
              <h5 className="mb-0">Our Brands</h5>
              <br></br>
              <p>
                Our selection includes a variety of products from top brands.
                Source all the essentials for your business from one source.
              </p>

              <div className="product-card__content mt-16 ">
                <Link
                  to="/"
                  className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                  tabIndex={0}
                >
                  Go to E-shop
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="container container-lg">
          <div className="row gy-4">
            <img
              src={bannerData?.hero_image?.files?.large?.url}
              alt=""
              className="banner-inner bg-overlay z-1 position-relative py-6 bg-img bg-start"
            />
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-between flex-wrap mt-40 mb-32 gap-16">
          <form action="#" className="input-group w-100 max-w-418">
            <input
              type="text"
              className="form-control common-input rounded-start-3"
              placeholder="Searching..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button
              type="submit"
              className="input-group-text border-0 bg-main-600 rounded-end-3 text-white text-2xl hover-bg-main-two-700 px-24"
            >
              <i className="ph ph-magnifying-glass" />
            </button>
          </form>
          <div className="d-flex align-items-center justify-content-between justify-content-sm-end gap-16 flex-grow-1">
            <span className="text-gray-900">
              Showing{" "}
              {filteredSection.length > 0 ? `1-${filteredSection.length}` : "0"}{" "}
              of {(section || []).length > 0} results
            </span>
            <div className="d-flex align-items-center gap-8 d-sm-flex d-none">
              <button
                type="button"
                onClick={() => setViewType("list")}
                className={`w-44 h-44 flex-center border rounded-6 text-2xl list-btn ${
                  viewType === "list"
                    ? "border-main-600 text-white bg-main-600"
                    : "border-gray-100 text-black bg-white"
                }`}
              >
                <i className="ph-bold ph-list-dashes" />
              </button>
              <button
                onClick={() => setViewType("grid")}
                className={`w-44 h-44 flex-center border rounded-6 text-2xl grid-btn ${
                  viewType === "grid"
                    ? "border-main-600 text-white bg-main-600"
                    : "border-gray-100 text-black bg-white"
                }`}
              >
                <i className="ph ph-squares-four" />
              </button>
            </div>
            {/* <div className="flex-align gap-8">
              <span className="text-gray-900 flex-shrink-0 d-sm-block d-none">
                Sort by:
              </span>
              <select
                className="common-input form-select rounded-pill border border-gray-100 d-inline-block ps-20 pe-36 h-48 py-0 fw-medium"
                defaultValue={1}
              >
                <option value={1}>Latest</option>
                <option value={1}>Old</option>
              </select>
            </div> */}
            <button
              onClick={sidebarController}
              type="button"
              className="w-48 h-48 d-lg-none d-flex flex-center border border-gray-100 rounded-6 text-2xl sidebar-btn"
            >
              <i className="ph-bold ph-funnel" />
            </button>
          </div>
        </div>

        <div className="short-product">
          <div className="container container-lg">
            <div className="row gy-4">
              {filteredSection.length > 0 &&
                filteredSection.map((val, index) => (
                  <div
                    key={index}
                    className={
                      viewType === "grid"
                        ? "col-xxl-2 col-lg-3 col-sm-4 col-6 d-flex"
                        : "col-12"
                    }
                  >
                    <div className="product-card d-flex flex-column h-100 p-8 border border-blue-100 hover-border-main-600 rounded-16 position-relative transition-2">
                      <div className="product-card__thumb rounded-8 bg-light-grey position-relative">
                        <Link
                          to="/product-details-two"
                          className="w-100 h-100 flex-center"
                        >
                          <img
                            src={
                              val?.attributes?.brand?.logo?.files?.small?.url
                            }
                            alt=""
                            className="w-100 h-100"
                          />
                        </Link>
                      </div>

                      <h6 className="title text-lg fw-semibold mt-12 mb-8">
                        {val?.attributes?.brand?.name}
                      </h6>
                      <p>{val?.attributes?.description}</p>

                      <div className="product-card__content p-sm-2 mt-auto"></div>

                      <div className="product-card__content mt-16 w-100">
                        <a
                          href={val?.attributes?.brand_website}
                          className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                          tabIndex={0}
                        >
                          Discover Products
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ourbrand;
